import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import React, {useContext, useEffect, useState} from "react";
import {EventIntf} from "../ServerTypes";
import Hls from "hls.js";
import {MessageContext} from "../../MessageContext";
import {makeStyles} from "@material-ui/core/styles";
import {AppContext} from "../../AppContext";
import {VideoRoomInfo} from "../gamestuff/VenueDefinition";
import {Checkbox} from "@material-ui/core";
import {GameContext} from "../GameContext";

const useStyles = makeStyles((theme) => ({
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

export default function VideoStreamManager(props: {event:EventIntf, roomInfo:VideoRoomInfo, resizeTrigger: () => void}){

    const [streamActive, setStreamActive] = useState(false)
    const [streamModal, setStreamModal] = useState(false)
    const [streamLive, setStreamLive] = useState(false)
    const [streamStatus, setStreamStatus] = useState("idle")
    const [adminVenueData, setAdminVenueData] = useState<any>(null)

    const classes = useStyles();

    const appContext = useContext(AppContext)
    const messageContext = useContext(MessageContext)
    const gameContext = useContext(GameContext)

    /*useEffect(() => {
        if(props.event) {
            const d = JSON.parse(props.event.static_venue_data)
            const intervalId = setInterval(() => {
                fetch(`https://api.mux.com/video/v1/live-streams/${d[props.roomInfo.roomKey].id}`, {
                    headers: new Headers({
                        "Authorization": `Basic ${btoa(`${process.env.REACT_APP_MUX_TOKEN_ID}:${process.env.REACT_APP_MUX_TOKEN_SECRET}`)}`
                    })
                })
                    .then(response => response.json())
                    .then(streamInfo => {
                        setStreamStatus(streamInfo.data.status)
                        setStreamLive(streamInfo.data.status === "active")
                    })

            }, 5000)
            return () => clearInterval(intervalId)
        }
    }, [props.event, props.roomInfo.roomKey])*/

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/event-admin-venue-data/${props.event.id}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                const d = JSON.parse(data.admin_venue_data)
                setAdminVenueData(d)
            })
    }, [props.event])

    useEffect(() => {

        setTimeout(() => {
            if(props.event && streamLive) {
                const d = JSON.parse(props.event.static_venue_data)
                const playbackId = d[props.roomInfo.roomKey].playback_id;
                const url = "https://stream.mux.com/" + playbackId + ".m3u8";
                const video = document.getElementById("main_video");

                if (video && video instanceof HTMLMediaElement) {
                    // If HLS.js is supported on this platform
                    if (Hls.isSupported()) {
                        const hls = new Hls();
                        hls.loadSource(url);
                        hls.attachMedia(video);
                        hls.on(Hls.Events.MANIFEST_PARSED, () => {
                            video.play();
                        });

                        // If the player can support HLS natively
                    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                        video.src = url;
                        video.addEventListener('loadedmetadata', () => {
                            video.play();
                        });
                    }
                }
            }
        }, 500)
    }, [props.event, streamLive])

    useEffect(() => props.resizeTrigger(), [props.event, streamLive])

    const updateVideo = () => {

        if(props.event == null)
            return

        const venueData = JSON.parse(props.event.venueData)
        venueData[`${props.roomInfo.roomKey}Active`] = streamActive
        venueData[`${props.roomInfo.roomKey}UserId`] = (appContext.currentUser as any).id
        venueData[`${props.roomInfo.roomKey}Modal`] = streamModal
        let newJson = JSON.stringify({
            venueData: JSON.stringify(venueData)
        });
        console.log("newJson", newJson)
        fetch(`${process.env.REACT_APP_API_CALL}/events/${props.event.id}`, {
            method: "PATCH",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: newJson
        })
            .then(response => response.json())
            .then(response => {
                messageContext.showSuccessMessage("Video info has been updated")
            })
    }

    useEffect(updateVideo, [streamActive, streamModal])

    const handleChange = (event:any) => {
        setStreamModal(event.target.checked);
    };

    const findStreamKey = () => {
        if(adminVenueData)
            return adminVenueData[props.roomInfo.roomKey].stream_key
        else
            return ""
    }

    return <React.Fragment>
        <Typography variant="h6" gutterBottom>
            Video Info {props.roomInfo.roomName}
        </Typography>
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
                Stream Key: {findStreamKey()}
            </Typography>
        </Grid>
        <Grid item xs={12}>
            Modal:
            <Checkbox
                checked={streamModal}
                onChange={handleChange}
                inputProps={{'aria-label': 'primary checkbox'}}
            />
        </Grid>
        {streamLive ?
            <Grid item xs={12}>
                <video width={480} height={270} muted id="main_video" autoPlay={true} controls></video>
            </Grid>
            :
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                    Stream Status: {streamStatus}
                </Typography>
            </Grid>
        }

        <Grid item xs={6}>
            {streamActive ?
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!streamLive && !streamActive}
                    onClick={() => setStreamActive(false)}
                    className={classes.button}
                >
                    Close Main Stream
                </Button>
                :
                <Button
                    variant="contained"
                    color="secondary"
                    disabled={!streamLive}
                    onClick={() => setStreamActive(true)}
                    className={classes.button}
                >
                    Go Live!
                </Button>
            }

        </Grid>
    </React.Fragment>
}
